import axios from "axios";
import axiosInstance from "../../translator";
import { machineCatalogueAPI as machineCatalog } from "../../constants/apis/apiEndpoints";
import { translator } from "../../constants/actionTypes";
import { customCloudProviderHeader } from "../../constants/componentConstants";

export const fetchCatalogLabsList = async (payload) => {
  let url = "";
  if (payload?.isMasterCatalog) {
    url = machineCatalog?.catalogue_master;
  } else {
    url = `${machineCatalog?.catalogueSku}${payload.urlParams}`;
  }
  return axiosInstance
    .get(`${url}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createVmApi = async (data) => {
  return axiosInstance
    .post(`${machineCatalog?.request}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createVmAdminApi = async (data) => {
  return axiosInstance
    .post(`${machineCatalog?.createVMAdmin}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const labViewApi = async (data, isManageVm, tenantId) => {
  return axiosInstance
    .get(isManageVm ? `${machineCatalog?.cloudLab}/${data}` : `${machineCatalog?.catalogueSku}/${data}?tenant_id=${tenantId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const updateBaseTemplateRequest = async ({ payload, id }) => {
  return axiosInstance
    .patch(`${machineCatalog?.catalogueSku}/${id}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const listExtensionAndBasePackRequest = async (payload) => {
  return axiosInstance
    .post(`${machineCatalog?.listExtensionAndBasePack}`, payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const checkVmCreateQuota = async (payload = "") => {
  const vmQuota = axiosInstance
    .get(`${machineCatalog?.checkVMCreateQuota}${payload}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return vmQuota;
};

export const checkVmExtendQuota = async (payload = "") => {
  const vmQuota = axiosInstance
    .get(`${machineCatalog?.checkVMExtendQuota}${payload}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  return vmQuota;
};

export const resetQuotaValue = async (payload) => {
  return axiosInstance
    .patch(`${machineCatalog?.resetQuota}/${payload?.tenantId}?userid=${payload?.userId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchCloudCatalogList = async (urlParams) => {
  return axios
    .get(`${translator.baseURL}${machineCatalog?.cloudCatalog}${urlParams}`, customCloudProviderHeader())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retrieveCloudCatalog = async (id, urlParams) => {
  return axios
    .get(`${translator.baseURL}${machineCatalog?.cloudCatalog}/${id}${urlParams}`, customCloudProviderHeader())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const retrieveCloudLabExtension = async (urlParams) => {
  return axios
    .get(`${translator.baseURL}${machineCatalog?.cloudLabExtension}${urlParams}`, customCloudProviderHeader())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const applyCloudLabExtensionApi = async (data) => {
  return axios
    .post(`${translator.baseURL}${machineCatalog?.cloudLabExtension}`, data, customCloudProviderHeader())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchCloudLabList = async (urlParams) => {
  return axios
    .get(`${translator.baseURL}${machineCatalog?.cloudLab}${urlParams}`, customCloudProviderHeader())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
};

export const createCloudLabApi = async (data) => {
  return axios
    .post(`${translator.baseURL}${machineCatalog?.cloudLab}`, data, customCloudProviderHeader())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createCloudLabFeedbackApi = async (data) => {
  return axios
    .post(`${translator.baseURL}${machineCatalog?.cloudLabFeedback}`, data, customCloudProviderHeader())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const updateCloudLabFeedbackApi = async (data, id) => {
  return axios
    .put(`${translator.baseURL}${machineCatalog?.cloudLabFeedback}/${id}`, data, customCloudProviderHeader())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const listBaseTemplatesRequest = async (params) => {
  return axiosInstance
    .get(`${machineCatalog?.listBaseTemplate}`, { params })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const applyLabExtensionRequest = async ({ id, payload }) => {
  const url = id ? `${machineCatalog?.applyLabExtension}/${id}` : `${machineCatalog?.applyLabExtension}`;
  return id
    ? axiosInstance
      .put(url, payload)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      })
    : axiosInstance
      .post(url, payload)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
};

export const exportTenantCatalogApi = async (id) => {
  return axiosInstance
    .get(`${machineCatalog?.catalogExport}?tenant_id=${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteCloudLabApi = async (id) => {
  return axios
    .delete(`${translator.baseURL}${machineCatalog?.cloudLab}/${id}`, customCloudProviderHeader())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
